<div class="review-div" [ngClass]="{ 'review-div-room-list': isRoomListPage }">
  <div class="theme-card">
    <div class="card-container">
      <room-background-card [theme]="theme"></room-background-card>
    </div>
  </div>
  <div class="room-info">
    <div class="room-name">
      <div class="room-name-container">
        {{ roomName }}
      </div>

      @if (isRoomListPage) {
        <div class="more-options">
          <button class="kebab-btn m-l-10" [matMenuTriggerFor]="menu" [attr.data-testid]="room?.name">
            <mat-icon class="kebab-menu-icon">more_vert</mat-icon>
          </button>
          <mat-menu role="menu" #menu="matMenu" xPosition="before" class="saved-rooms-options-menu">
            <button
              id="saved-rooms-share-button"
              type="button"
              mat-menu-item
              role="menuitem"
              (click)="onShareLink(room)"
              data-testid="share-button"
            >
              Share Link
            </button>
            <button
              type="button"
              mat-menu-item
              role="menuitem"
              (click)="onDuplicateRoom(room)"
              data-testid="duplicate-button"
            >
              Duplicate
            </button>

            <button
              type="button"
              mat-menu-item
              role="menuitem"
              (click)="onDeleteRoom(room)"
              data-testid="delete-button"
            >
              Delete
            </button>
          </mat-menu>
        </div>
      }
    </div>

    <div class="room-desc">
      <div>{{ roomSizeInfo?.capacity }} Max room capacity | {{ playlist?.name ?? 'None' }}</div>
      <div>Created by {{ formatUserName() }}</div>
    </div>
    <div class="room-footer">
      @if (roomSizeInfo) {
        <div class="roomSizeInfo room-size-label">
          <span>{{ roomSizeInfo.label }} Room</span>
        </div>
      }

      <div class="room-buttons">
        <button
          data-testid="enterButton"
          [ngClass]="{ 'disabled-button': !isRoomListPage }"
          class="footer-buttons"
          [disabled]="!isRoomListPage"
          (click)="onEnterRoom()"
        >
          Enter
          @if (!isRoomListPage) {
            <mat-icon class="button-footer" svgIcon="ENTER_ICON"></mat-icon>
          }
        </button>
        <button
          data-testid="customizeButton"
          [ngClass]="{ 'disabled-button': !isRoomListPage }"
          class="footer-buttons"
          [disabled]="!isRoomListPage"
          (click)="onEditRoom(room)"
        >
          Edit
          <mat-icon
            class="button-footer"
            [svgIcon]="isRoomListPage ? 'ROUNDED_ARROW_RIGHT_NAVY' : 'ROUNDED_ARROW_RIGHT'"
          ></mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
